import React, { useEffect, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";
import * as env from "~/common/constants/env";

import { useForm } from "react-hook-form";
import { useGlobalStore } from "~/store";

import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import Tag from "~/common/components/Tag";
import Address from "~/common/components/Address";
import NumberInput from "~/common/components/NumberInput";
import DatePicker from "~/common/components/DatePicker";
import Select, { optionsGenerator } from "~/common/components/Select";
import PageHeader from "~/common/components/PageHeader";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import SingleImageUploader from "~/common/components/ImageUploader/SingleImageUploader";
import SignatureSelectModal from "~/common/components/SignatureSelectModal";
import SignaturePolicyModal from "~/pages/mypage/admin/SignaturePage/modal/policy/SignaturePolicyModal";

import "~/assets/sass/pages/vcInfo/edit.scss";
import { PlusIcon } from "~/assets/svg/MathIcon";
import RectangleInitialImg from "~/assets/img/logo-rec.jpg";
import { INVEST_TYPE } from "~/common/constants/form";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import useAlert from "~/common/hooks/useAlert";
import { useTranslation } from "react-i18next";
import { UPLOAD_TYPE } from "~/common/constants/upload";
import axios from "axios";
import { dateFormatter } from "~/utils/formatter";
import { isDate } from "date-fns";
import File from "~/pages/mypage/admin/SignaturePage/modal/upload/components/File";
import { QuestionMarkIcon } from "~/assets/svg/InterfaceIcon";
import BusinessAuth from "../BusinessAuth";

Quill.register("modules/imageResize", ImageResize);

export const biznumQuery = (data) => {
	return axios.patch(`${env.EM_COMPANY_API_URL}/company/num`, data);
};

const Edit = ({ setPage, menu, type }) => {
	const { t } = useTranslation();
	const [showAlert, Alert] = useAlert();

	const infoModifyRequest = useRequest("post", "/vc/company/info/edit");
	const userSignatureRequest = useRequest("get", "vc/user/signature");
	const signatureListRequest = useRequest("get", `/vc/admin/signature`);

	const [{ company }] = useGlobalStore();
	const [logoRec, setLogoRec] = useState(company.info.logoRec ? company.info.logoRec : "");

	const [
		{
			company: { info },
		},
	] = useGlobalStore();

	const vcInfoForm = useForm({
		defaultValues: {
			...{
				...info?.company,
				CompanyKeyword: info?.CompanyKeyword?.map((d) => d.content),
				estDate: info.estDate ?? new Date(),
			},
		},
	});


	const [logoEditWarningAlert, setLogoEditWarningAlert] = useState(false);
	const [showModifyAlert, ModifyAlert] = useAlert();

	const [digitalDataModal, setDigitalDataModalModal] = useState(false);
	const [signatureUploadModal, setSignatureUploadModal] = useState(false);

	const vcName = vcInfoForm.watch("name");
	const documentTitle = vcName?.trim() ? vcName : t("pages.vcInfo.VcInformation.Detail.vcName");

	const [certImg, setCertImg] = useState(null); // imgUrl
	const [signImg, setSignImg] = useState(null); // sign img info
	const [signatureModal, setSignatureModal] = useState(false);
	const [intContent, setIntContent] = useState("");
	const [tempSignature, setTempSignature] = useState();
	const [saveBuiznessInfo, setSaveBuiznessInfo] = useState(false);
	const [signList, setSignList] = useState([]);

	useEffect(() => {
		info && setIntContent(info.introContent);
	}, [info]);


	const quillRef = useRef(null);
	const signature = vcInfoForm.watch("signature");
	const setSignature = (signature) => {
		vcInfoForm.setValue("signature", signature);
	};

	useEffect(() => {
		userSignatureRequest.singleCall();
		signatureListRequest.singleCall();
	}, []);

	useEffect(() => {
		switch (signatureListRequest.state) {
			case API_STATE.done:
				setTempSignature(
					signatureListRequest.response.data.find((s) => s.img === signature)
				);
				const activateImg = signatureListRequest.response.data?.filter(item => item.activation);
				setSignature(activateImg?.[0]?.img ?? "");
				setSignList(signatureListRequest.response.data)
				break;
			case API_STATE.error:
				console.log("error > ", signatureListRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [signatureListRequest.state, signatureListRequest.error, signatureListRequest.response]);



	const submit = (data) => {
		setSaveBuiznessInfo(true);

		console.log("post data -> ", {
			CompanyInfo: {
				address: data.address,
				addressDetail: data.addressDetail,
				ceoContact: data.ceoContact,
				ceoEmail: data.ceoEmail,
				ceoName: data.ceoName,
				employeeNum: data.employeeNum,
				estDate: data.estDate,
				fax: data.fax,
				homepage: data.homepage,
				introContent: data.introContent,
				introTitle: data.introTitle,
				listed: data.listed,
				logoRec: data.logoRec,
				logoSqu: data.logoSqu,
				name: data.name,
				regDate: data.regDate,
				regNum: data.regNum,
				// signImg: data.signImg,
				type: data.type,
				zipCode: data.zipCode,
			},
			CompanyKeyword: data.CompanyKeyword,
			certImg: certImg ?? "",
			signIdx: signImg?.idx ?? ""
		});


		infoModifyRequest.call({
			CompanyInfo: {
				address: data.address,
				addressDetail: data.addressDetail,
				ceoContact: data.ceoContact,
				ceoEmail: data.ceoEmail,
				ceoName: data.ceoName,
				employeeNum: data.employeeNum,
				estDate: data.estDate,
				fax: data.fax,
				homepage: data.homepage,
				introContent: data.introContent,
				introTitle: data.introTitle,
				listed: data.listed,
				logoRec: data.logoRec,
				logoSqu: data.logoSqu,
				name: data.name,
				regDate: data.regDate,
				regNum: data.regNum,
				// signImg: data.signImg,
				type: data.type,
				zipCode: data.zipCode,
			},
			CompanyKeyword: data.CompanyKeyword,
			certImg: certImg ?? "",
			signIdx: signImg?.idx ?? ""
		});
	};


	useEffect(() => {
		setSignImg(info?.signature);
		setCertImg(info?.certificate?.imgUrl);
	}, []);


	const quillModules = {
		imageResize: {
			displayStyles: {
				backgroundColor: "black",
				border: "none",
				color: "white",
			},
			modules: ["Resize", "DisplaySize", "Toolbar"],
		},
		toolbar: [
			["bold", "italic", "underline", "strike", "blockquote"],
			[{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
			["link"],
			["clean"],
		],
	};

	const quillFormats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"blockquote",
		"list",
		"bullet",
		"indent",
		"link",
		"image",
		"align",
		"color",
		"background",
	];
	const [uploadImgCompleted, setUploadImgCompleted] = useState(false);
	const uploadImg = () => {
		setUploadImgCompleted(true);
		vcInfoForm.setValue("logoRec", logoRec);
		setLogoEditWarningAlert(false);
	};

	useEffect(() => {
		switch (infoModifyRequest.state) {
			case API_STATE.done:
				setPage("detail");
				break;
			case API_STATE.error:
				console.log("error > ", infoModifyRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [infoModifyRequest.state, infoModifyRequest.error, infoModifyRequest.response]);

	useEffect(() => {
		vcInfoForm.register("introContent", {
			required: true,
			defaultValues: info.introContent || "",
		});
	}, [vcInfoForm.register]);


	const buttonList = [
		<button
			type="button"
			className="btn__solid"
			onClick={vcInfoForm.handleSubmit(submit)}
			color="primary"
		>
			{t("pages.vcInfo.VcInformation.Edit.save")}
		</button>,
		<button
			type="button"
			className="btn__solid"
			color="gray"
			onClick={() => {
				showModifyAlert().then(() => {
					setPage("detail");
				});
			}}
		>
			{t("pages.vcInfo.VcInformation.Edit.cancel")}
		</button>,
	];

	const imageRender = () => {
		// 1. 처음 렌더링할때
		if (info.logoRec && !uploadImgCompleted)
			return (
				<div className="logo-wrap after">
					<img
						src={info.logoRec || RectangleInitialImg}
						alt={t("pages.vcInfo.VcInformation.Edit.logo")}
						onError={(e) => {
							e.target.src = RectangleInitialImg;
						}}
					/>
					<span>{t("pages.vcInfo.VcInformation.Edit.logoEdit")}</span>
				</div>
			);
		// 2. 모달창 저장하고 난후
		if (vcInfoForm.watch("logoRec"))
			return (
				<div className="logo-wrap after">
					<img
						src={vcInfoForm.watch("logoRec") || RectangleInitialImg}
						alt={t("pages.vcInfo.VcInformation.Edit.logo")}
						onError={(e) => {
							e.target.src = RectangleInitialImg;
						}}
					/>
					<span>{t("pages.vcInfo.VcInformation.Edit.logoEdit")}</span>
				</div>
			);
		// 로고 없을경우
		else
			return (
				<div className="logo-wrap before">
					<span>{t("pages.vcInfo.VcInformation.Edit.logoEnroll")}</span>
				</div>
			);
	};

	return (
		<>
			<PageHeader {...{ menu, type, buttonList }} />
			<div className="c__card vc-info-edit">
				<div className="head-wrap">
					<h2 className="vc-name">{documentTitle}</h2>
					<section className="vc-logo" onClick={() => setLogoEditWarningAlert(true)}>
						{imageRender()}
					</section>
				</div>
				<div className="data-form">
					<section className="input-group-section">
						<h3 className="section-title">
							{t("pages.vcInfo.VcInformation.Edit.basicInfo")}
						</h3>
						<Form useForm={vcInfoForm}>
							<Group
								label={<>사업자등록번호</>}
								className={"registration-num"}
								required
							>
								<NumberInput
									placeholder="000-00-00000"
									name="regNum"
									type="company"
									required
								/>
								{/* <button
									type="button"
									className="btn__outline btn__api angled"
									color="primary"
									onClick={findCompany}
								>
									정보 불러오기
								</button> */}
							</Group>
							<Input
								label={t("pages.vcInfo.VcInformation.Edit.vcName")}
								name="name"
								required
							/>
							<Select
								label={t("pages.vcInfo.VcInformation.Edit.typeInvest")}
								name="type"
								options={optionsGenerator(INVEST_TYPE)}
								required
							/>
							<DatePicker
								label={t("pages.vcInfo.VcInformation.Edit.establish")}
								name="estDate"
								required
							/>
							<Input
								label={t("pages.vcInfo.VcInformation.Edit.present")}
								name="ceoName"
								required
							/>
							<NumberInput
								label={t("pages.vcInfo.VcInformation.Edit.employeeNumber")}
								name="employeeNum"
								required
							/>
							<Input
								label={t("pages.vcInfo.VcInformation.Edit.email")}
								type="email"
								name="ceoEmail"
								placeholder="sample@domain.com"
								required
								validation={{
									pattern: {
										value: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,
										message: t("pages.vcInfo.VcInformation.Edit.includingAt"),
									},
								}}
							/>
							<NumberInput
								label={t("pages.vcInfo.VcInformation.Edit.contact")}
								name="ceoContact"
								type="phone"
								placeholder="010-0000-0000"
								required
							/>
							<NumberInput
								label={t("pages.vcInfo.VcInformation.Edit.faxNumber")}
								type="phone"
								name="fax"
								placeholder="02-0000-0000"
							/>
							<Input
								label={t("pages.vcInfo.VcInformation.Edit.homepage")}
								name="homepage"
							/>
							<Address
								label={t("pages.vcInfo.VcInformation.Edit.address")}
								name={{
									postCode: "zipCode",
									address1: "address",
									address2: "addressDetail",
								}}
								required
							/>
							<Tag
								label={t("pages.vcInfo.VcInformation.Edit.interests")}
								name="CompanyKeyword"
								className="c__tag-wrap"
							/>
						</Form>
					</section>
					<section className="vc-desc">
						<h3 className="section-title">
							{t("pages.vcInfo.VcInformation.Edit.introduce")}
						</h3>
						<Form useForm={vcInfoForm}>
							<Input name="introTitle" required />
							<ReactQuill
								ref={quillRef}
								theme={"snow"}
								name={"introContent"}
								className={`${vcInfoForm.formState.errors.introContent ? "has-error" : ""
									}`}
								modules={quillModules}
								formats={quillFormats}
								value={vcInfoForm.watch("introContent") ?? ""}
								onChange={(e) =>
									vcInfoForm.setValue(
										"introContent",
										e === "<p><br></p>" ? "" : e
									)
								}
								placeholder={t("pages.vcInfo.VcInformation.Edit.enterDetails")}
							/>

							{/*<ReactQuill*/}
							{/*	theme="snow"*/}
							{/*	name="introContent"*/}
							{/*	className={`${vcInfoForm.formState.errors.introContent ? "has-error" : ""*/}
							{/*	}`}*/}
							{/*	modules={quillModules}*/}
							{/*	formats={quillFormats}*/}
							{/*	value={vcInfoForm.watch("introContent")}*/}
							{/*	onChange={(e) =>*/}
							{/*		vcInfoForm.setValue(*/}
							{/*			"introContent",*/}
							{/*			e === "<p><br></p>" ? "" : e*/}
							{/*		)*/}
							{/*	}*/}
							{/*	placeholder={t("pages.vcInfo.VcInformation.Edit.enterDetails")}*/}
							{/*/>*/}
							{vcInfoForm.formState.errors.introContent && (
								<p className="f__feedback">필수 입력 사항 입니다.</p>
							)}
						</Form>
					</section>
					<section className="footer-wrapper">
						<BusinessAuth edit
							//saveBuiznessInfo={saveBuiznessInfo} 
							setCertImg={setCertImg}
							info={info}
						/>
					</section>
					<section>
						<div className="seal-area">
							<span className="seal-label">Signature</span>
							<div className="seal-uploader">
								{/*서명 등록전*/}
								{signature ? (
									<SingleImageUploader
										img={signature}
										setImg={setSignature}
										imgType={tempSignature?.type || ""}
										width={236}
										height={122}
										deletable={false}
										editable={true}
										handleEdit={() => setSignatureModal(true)}
									/>
								) : (
									<button
										className="dashed-btn plus-btn"
										type="button"
										onClick={() => setSignatureModal(true)}
									>
										<PlusIcon />
										{t("pages.vcInfo.VcInformation.Edit.resisterSign")}
									</button>
								)}
							</div>
						</div>
					</section>
				</div>
			</div>

			{/* 법인인감 등록/수정하기 */}
			<ModalTemplate
				modalState={signatureModal}
				setModalToggle={setSignatureModal}
				title={"법인 인감 등록하기"}
				width={700}
				className={"modal-sign"}
			>
				<SignatureSelectModal
					selectedSignature={signature}
					setSelectedSignature={setSignature}
					setDigitalDataModalModal={setDigitalDataModalModal}
					signatureListRequest={signatureListRequest}
					setSignImg={setSignImg}
					signList={signList}
				/>
			</ModalTemplate>

			{/* 범인인감 POLICY */}
			<ModalTemplate
				title={t("pages.myPage.admin.SignaturePage.digitalDataModal")}
				modalState={digitalDataModal}
				setModalToggle={setDigitalDataModalModal}
				width={500}
				height={502}
				className="digital-data-modal"
			>
				<SignaturePolicyModal
					setSignatureUploadModal={setSignatureUploadModal}
					setDigitalDataModalModal={setDigitalDataModalModal}
				/>
			</ModalTemplate>

			{/* 법인인감 UPLOAD */}
			<ModalTemplate
				title={t("pages.myPage.admin.SignaturePage.signatureUploadModal")}
				modalState={signatureUploadModal}
				setModalToggle={setSignatureUploadModal}
				width={500}
				height={380}
				className="signatureUpload-modal vc-info"
			>
				<div className="modal-content">
					<div className={`signature-file`}>
						<File
							setModalToggle={setSignatureUploadModal}
							userSignatureRequest={userSignatureRequest}
							signatureListRequest={signatureListRequest}
						/>
					</div>
				</div>
			</ModalTemplate>

			{/* 로고 UPLOAD */}
			<ModalTemplate
				title={"로고 등록하기"}
				modalState={logoEditWarningAlert}
				setModalToggle={setLogoEditWarningAlert}
				width={460}
				height={480}
				className="modal-logo"
			>
				<div className="modal-content">
					<p className="sub-text">
						직사각형 로고 <b>(220X85 이상)</b>
					</p>
					<div className="logo-uploader">
						<div className={`logo-wrap ${logoRec ? "logo-exist" : ""}`}>
							<SingleImageUploader
								uploaderConstant={UPLOAD_TYPE.COMPANY_LOGO}
								width={"100%"}
								height={"100%"}
								img={logoRec}
								setImg={setLogoRec}
							/>
						</div>
					</div>
					<div className="info-text">
						<p>* 용량 : 5MB 이하 / 지원 파일 형식 : gif, png, jpg(jpeg)</p>
						<p>* 권장 사이즈 보다 크거나 작으면 깨져서 보일 수 있습니다.</p>
					</div>
				</div>
				<div className="modal-footer">
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setLogoEditWarningAlert(false)}
					>
						취소
					</button>
					<button className="btn__solid" color="primary" onClick={uploadImg}>
						저장
					</button>
				</div>
			</ModalTemplate>

			<ModifyAlert
				type="warning"
				layout="horiz"
				message={
					<>
						<h3>{t("pages.vcInfo.VcInformation.Edit.wouldCancel")}</h3>
						<p>{t("pages.vcInfo.VcInformation.Edit.notSave")}</p>
					</>
				}
				reject={t("pages.vcInfo.VcInformation.Edit.non")}
				confirm={t("pages.vcInfo.VcInformation.Edit.yes")}
				height={230}
			/>

			<Alert message={"조회된 기업이 없습니다."} confirm={"확인"} type={"info"} />
		</>
	);
};

export default Edit;
